export const nl = {
  title: 'Primaire bossen',
  subtitle: '30m, tropen, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Functie',
      value:
        'Deze dataset brengt de omvang van de primaire bossen in de mondiale pantropische gebieden in 2001 in kaart.',
    },
    {
      label: 'Resolutie',
      value: '30×30 meter',
    },
    {
      label: 'Geografische dekking',
      value: 'Pan-tropisch',
    },
    {
      label: 'Bron',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. en Hansen, M.C., 2018. Aanhoudend verlies van primair bos in Brazilië, de Democratische Republiek Congo en Indonesië. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Datum van inhoud',
      value: 2001,
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Oerbossen behoren tot de meest biodiverse bossen en leveren een groot aantal ecosysteemdiensten, waardoor ze van cruciaal belang zijn voor de monitoring van de nationale landgebruiksplanning en koolstofboekhouding. Deze dataset definieert oerbossen als "volwassen natuurlijke vochtige tropische bosbedekking die in de recente geschiedenis niet volledig is gekapt en opnieuw is gegroeid." Onderzoekers classificeerden Landsat-beelden in primaire bosgegevens, waarbij voor elke regio een afzonderlijk algoritme werd gebruikt.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. en Hansen, M.C., 2018. Aanhoudend verlies van primair bos in Brazilië, de Democratische Republiek Congo en Indonesië. Environmental Research Letters, 13(7), p.074028. Toegankelijk via Global Forest Watch op 31/01/2025. www.globalforestwatch.org.',
  },
};
